import { createThemeOverride, portalNameThemeMap } from '@uhg-psx/theme-utils';

import { PortalIdentifier, PortalName } from '../../common/Portal';

export interface ClientPortalConfig {
  portalName: PortalName;
  theme: 'uhc' | 'optum';
  portalIdentifier?: PortalIdentifier;
  themeVersion?: 'v1' | 'v2';
  themeOverride?: any;
}

export const COVERAGE_TYPE_HOME_PATH_MAP: Record<string, string> = {
  B: '/?chipValue=Behavioral%20Health&coverageType=B',
  D: '/?chipValue=Dental&coverageType=D',
  V: '/?chipValue=Vision&coverageType=V',
};

export const CLIENT_PORTAL_CONFIG_MAP: Record<string, ClientPortalConfig> = {
  geha: {
    portalName: PortalName.UMR,
    theme: 'uhc',
    portalIdentifier: PortalIdentifier.GEHA,
    themeVersion: 'v2',
    themeOverride: createThemeOverride(
      portalNameThemeMap[PortalIdentifier.GEHA].v2 ||
        portalNameThemeMap[PortalIdentifier.GEHA].v1
    ),
  },
  umr: {
    portalName: PortalName.UMR,
    theme: 'uhc',
  },
  laww: {
    portalName: PortalName.LAWW,
    theme: 'optum',
  },
  default: {
    portalName: PortalName.GUEST_PLAN_SELECTION,
    theme: 'uhc',
  },
};
